import axios from 'axios';
import { settings } from '../config';

export async function fetchGiveaways(id?: number) {
  const config = {
    headers: {
      Authorization: 'Bearer 4478c2b6-525f-4b48-99a2-1e9e7da835b7',
    },
  };
  try {
    const url = id
      ? `${settings.url}/giveaway/${id}`
      : `${settings.url}/giveaway/`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (e) {
    console.log('ОШИБКА', e);
  }
}

export async function purchaseCoupon(
  giveaway_id: number,
  amount: number,
  couponType: string,
) {
  const config = {
    headers: {
      Authorization: 'Bearer 4478c2b6-525f-4b48-99a2-1e9e7da835b7',
    },
  };
  try {
    const url = `${settings.url}/giveaway/${giveaway_id}/coupon`;
    const response = await axios.post(
      url,
      { quantity: amount, coupon_type: couponType },
      config,
    );
    return response.data;
  } catch (e) {
    console.log('ОШИБКА', e);
  }
}

export async function getGiveawayCoupons(giveaway_id: number, place: number) {
  const config = {
    headers: {
      Authorization: 'Bearer 4478c2b6-525f-4b48-99a2-1e9e7da835b7',
    },
  };
  try {
    const url = `${settings.url}/giveaway/${giveaway_id}/claim?place=${place}`;
    const response = await axios.post(url, {}, config);

    return response.data;
  } catch (e) {
    console.log('ОШИБКА', e);
  }
}
